// Vuetify 3 플러그인 (Vue 3 전환 단계에서 사용)
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { themePresetV3 } from '@/themeConfig.v3'

const resolveSelectTitle = (item) => {
  if (item === null || item === undefined) return ''
  if (typeof item === 'string' || typeof item === 'number') return String(item)
  if (Array.isArray(item)) return item.join(', ')
  if (typeof item === 'object') {
    return (
      item.title ??
      item.text ??
      item.name ??
      item.label ??
      item.value ??
      ''
    )
  }
  return String(item)
}

const vuetify = createVuetify({
  theme: themePresetV3.theme,
  rtl: themePresetV3.rtl,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VBtn: {
      density: 'default',
      size: 'default',
      variant: 'flat',
    },
    VTextField: {
      density: 'compact',
      variant: 'outlined',
    },
    VTextarea: {
      density: 'compact',
      variant: 'outlined',
    },
    VSelect: {
      density: 'compact',
      variant: 'outlined',
      itemTitle: resolveSelectTitle,
    },
    VAutocomplete: {
      density: 'compact',
      variant: 'outlined',
      itemTitle: resolveSelectTitle,
    },
    VCombobox: {
      density: 'compact',
      variant: 'outlined',
      itemTitle: resolveSelectTitle,
    },
    VDataTable: {
      density: 'compact',
    },
    VList: {
      density: 'compact',
    },
    VListItem: {
      density: 'compact',
    },
  },
})

export default vuetify
